import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateModule, TranslatePipe, TranslateService } from "@ngx-translate/core";
import { DocumentActionType } from "@shared/enums/document-action.type";
import { DocumentType } from "@shared/enums/documents.type";
import { PolicyStates } from "@shared/enums/policy-states";
import { DocumentsVm } from "@shared/models/policy-details";
import { DocumentName } from "@shared/models/quotation";
import { DocumentService } from "@shared/services/document.service";
import { Guid } from "guid-typescript";
import { forkJoin, lastValueFrom } from "rxjs";

@Component({
  selector: "app-documents-card",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./documents-card.component.html",
})
export class DocumentsCardComponent {
  @Input({ required: true }) documents!: DocumentsVm[];
  @Input() documentName!: DocumentName[];
  @Input() policyStatus?: PolicyStates;

  DocumentType = DocumentType;
  documentAttSCO: string[] = [];
  attscoIndex = -1;
  aviecheanceIndex = -1;
  translations: any[] = [];
  DocumentActionType = DocumentActionType;
  policyStates = PolicyStates;

  constructor(
    private translate: TranslateService,
    private documentService: DocumentService
  ) {}

  downloadDocument(documentType: DocumentType, actionType: DocumentActionType) {
    const documentId = this.getFileByDocumentType(documentType);
    if (!documentId) return; // Early return if no documentId exists
    if (this.policyStatus !== PolicyStates.Na && this.policyStatus !== this.policyStates.Terminated) {
      this.downloadDocumentApi(documentId, actionType); // If single document
    }
  }

  downloadDocumentApi(documentId: Guid, actionType: DocumentActionType) {
    this.documentService.getAgreementDocument(documentId).subscribe(data => {
      actionType == DocumentActionType.DOWNLOAD
        ? this.documentService.onDownload(documentId)
        : this.documentService.onView(documentId);
    });
  }

  // TODO: adapt the documents to the new version
  // V1 - WITH THE BACKEND MERGED WITH THE 1.1 VERSION
  public getFileByDocumentType(documentType: DocumentType): Guid | null {
    const doc = this.documents.find(d => d.documentTypeCode === documentType);
    return doc ? doc.documentId : null;
  }

  public getDocumentsByType(docType: DocumentType): DocumentsVm[] {
    return this.documents.filter(doc => doc.documentTypeCode === docType);
  }
}
